// src/services/api/storePickup.js
import { apiClient } from './base';

export const getStorePickupOrders = async (params = {}) => {
  const response = await apiClient.get('/store-pickup-orders', { params });
  return response.data;
};

export const dispatchStorePickupOrder = async (id, data) => {
  const response = await apiClient.patch(`/store-pickup-orders/${id}/dispatch`, data);
  return response.data;
};

export const updateStorePickupDeliveryNotes = async (id, deliveryNotes) => {
  const response = await apiClient.patch(`/store-pickup-orders/${id}/delivery-notes`, { deliveryNotes });
  return response.data;
};

export const getStorePickupOrderForPos = async (id) => {
  const response = await apiClient.get(`/store-pickup-orders/${id}/pos`);
  return response.data;
};

export const completeStorePickupOrderFromPos = async (id, data) => {
  const response = await apiClient.put(`/store-pickup-orders/${id}/complete-from-pos`, data);
  return response.data;
};

export const deleteStorePickupPaymentRecord = async (orderId, recordId) => {
  const response = await apiClient.delete(`/store-pickup-orders/${orderId}/payment-records/${recordId}`);
  return response.data;
};
